// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[class^=el-icon-][data-v-17f3d3f0]{font-size:1.2rem}.userText[data-v-17f3d3f0]{font-size:1rem}.languageTitle[data-v-17f3d3f0]{position:relative}.languageTitle:hover .languageGroup[data-v-17f3d3f0]{display:block}.languageTitle .languageHeader[data-v-17f3d3f0]{padding:.25rem 1.5rem;cursor:pointer}.languageTitle .languageHeader[data-v-17f3d3f0]:hover{background-color:#ddd}", ""]);
// Exports
module.exports = exports;
